export interface AssistantChatCornerRequest {
  requestId: number
  workerId: string
  sessionId: string | null
}

type VisibilityHandler = (visible: boolean) => void
type CornerRequestHandler = (request: AssistantChatCornerRequest) => void

const visibleEmbeddedSurfaces = new Set<string>()
const visibilityHandlers = new Set<VisibilityHandler>()
const cornerRequestHandlers = new Set<CornerRequestHandler>()
let pendingCornerRequest: AssistantChatCornerRequest | null = null
let requestSequence = 0

function publishVisibility() {
  const visible = visibleEmbeddedSurfaces.size > 0
  visibilityHandlers.forEach((handler) => handler(visible))
}

export function setEmbeddedAssistantChatVisible(surfaceId: string, visible: boolean) {
  const changed = visible
    ? !visibleEmbeddedSurfaces.has(surfaceId)
    : visibleEmbeddedSurfaces.has(surfaceId)
  if (!changed) return

  if (visible) visibleEmbeddedSurfaces.add(surfaceId)
  else visibleEmbeddedSurfaces.delete(surfaceId)
  publishVisibility()
}

export function subscribeEmbeddedAssistantChatVisibility(handler: VisibilityHandler) {
  visibilityHandlers.add(handler)
  handler(visibleEmbeddedSurfaces.size > 0)
  return () => {
    visibilityHandlers.delete(handler)
  }
}

export function openAssistantChatInCorner(request: Omit<AssistantChatCornerRequest, 'requestId'>) {
  const command = { ...request, requestId: requestSequence += 1 }
  if (cornerRequestHandlers.size === 0) pendingCornerRequest = command
  else cornerRequestHandlers.forEach((handler) => handler(command))
}

export function subscribeAssistantChatCornerRequests(handler: CornerRequestHandler) {
  cornerRequestHandlers.add(handler)
  if (pendingCornerRequest) {
    const request = pendingCornerRequest
    pendingCornerRequest = null
    handler(request)
  }
  return () => {
    cornerRequestHandlers.delete(handler)
  }
}
